import React, { useState } from 'react'
import { FormControl, TextField } from '@material-ui/core'
import { Link, withRouter } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close';

function Location(props) {
	const baseURL = process.env.PUBLIC_URL;
	const close = ()=>{
		props.history.replace(baseURL+'/dashboard')
	}

	return (
		<main>
			<header className="header-aux">
				<div></div>
				<h3>Contacto</h3>
				<CloseIcon onClick={close} />
			</header>
			<section className="container-plain">
				<p><strong>Correo Electrónico: </strong><a target="blank" href="mailto:lotusbjjmadrid@hotmail.com">lotusbjjmadrid@hotmail.com</a></p>
				<p><strong>Teléfono: </strong><a target="blank" href="https://wa.me/34634467296">34634467296</a></p>
				<p><strong>Dirección: </strong>Calle Agustín de Foxá, 25, Bajo C, 28036 Madrid</p>
				<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12140.8831102264!2d-3.6858177!3d40.4703805!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x447b75b07eb3ba8e!2sBJJ%20Madrid%20Academy!5e0!3m2!1ses!2ses!4v1602019565105!5m2!1ses!2ses" width="100%" height="420" frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
			</section>
		</main>
	)
}

export default withRouter(Location)